import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {
  faTimes,
  faSearch,
  faDownload,
  faFileAlt
} from '@fortawesome/fontawesome-free-solid'

import Api from '../../services/api'
import { BASE_URL } from '../../config'

// Lists the performance data files (weights, kill sheets) the processor has
// shared for a Lot. Only reachable from the owner's My Submitted Lots page.
class PerformanceDataModal extends PureComponent {
  async openDocLink (doc) {
    try {
      const res = await Api.getSignedUrl(doc.key)
      if (res && res.url) {
        window.open(res.url, '_blank')
      }
    } catch (err) {
      console.error('Failed to get document URL:', err)
    }
  }

  render () {
    const { isOpen, closeModal, documents } = this.props
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        overlayClassName='overlay'
        className='content'
        portalClassName='ReactModalPortal-Email'
      >
        <h2 className='modal-header'>Performance Data</h2>
        <span className='icon-close icon-danger' onClick={closeModal}>
          <FontAwesomeIcon icon={faTimes} />
        </span>
        <div className='modal-body performance-data-body'>
          {documents.map(doc => (
            <div className='performance-data-item' key={doc.key}>
              <div className='performance-data-info'>
                <FontAwesomeIcon className='file-icon' icon={faFileAlt} />
                <div className='file-text'>
                  <p className='description'>{doc.description || doc.name}</p>
                  {doc.description && <p className='file-name' title={doc.name}>{doc.name}</p>}
                </div>
              </div>
              <div className='performance-data-actions'>
                <a
                  className='view-link'
                  href='#'
                  onClick={(e) => {
                    e.preventDefault()
                    this.openDocLink(doc)
                  }}
                >
                  <span>View</span>
                  <FontAwesomeIcon icon={faSearch} />
                </a>
                <a
                  className='download-link'
                  download
                  target='_blank'
                  rel='noopener noreferrer'
                  href={`${BASE_URL}download-file/${doc.key}?fileName=${doc.name}`}
                >
                  <span>Download</span>
                  <FontAwesomeIcon icon={faDownload} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </Modal>
    )
  }
}

PerformanceDataModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  documents: PropTypes.array.isRequired
}

PerformanceDataModal.defaultProps = {
  documents: []
}

export default PerformanceDataModal
